const CU_LOG_RE = /Program (\w+) consumed (\d+) of (\d+) compute units/;
const CU_LIMIT_RE = /Requested compute unit limit: (\d+)/;
export function parseCuFromLogs(logs) {
    const perInstruction = new Map();
    let totalConsumed = 0;
    let limit = 1_400_000; // default
    if (!logs)
        return { perInstruction, totalConsumed, limit };
    // Track current instruction path by depth
    const stack = [];
    let topIndex = 0;
    for (const log of logs) {
        const limitMatch = log.match(CU_LIMIT_RE);
        if (limitMatch) {
            limit = parseInt(limitMatch[1], 10);
            continue;
        }
        const invokeMatch = log.match(/invoke \[(\d+)\]/);
        if (invokeMatch) {
            const depth = parseInt(invokeMatch[1], 10);
            const programMatch = log.match(/Program (\w+) invoke/);
            const program = programMatch ? programMatch[1] : 'Unknown';
            if (depth === 1) {
                stack.length = 0;
                topIndex++;
            }
            const id = depth === 1 ? `${topIndex - 1}-0` : `${topIndex - 1}-${stack.length}`;
            stack.push({ id, program });
            continue;
        }
        const cuMatch = log.match(CU_LOG_RE);
        if (cuMatch) {
            const consumed = parseInt(cuMatch[2], 10);
            totalConsumed += consumed;
            const frame = stack.pop();
            if (frame) {
                perInstruction.set(frame.id, (perInstruction.get(frame.id) ?? 0) + consumed);
            }
            continue;
        }
        if (log.includes('success') || log.includes('failed')) {
            // End of a program invocation; stack already popped by CU line
        }
    }
    return { perInstruction, totalConsumed, limit };
}
export function attachCuToTree(nodes, cuMap) {
    function walk(n) {
        n.cuConsumed = cuMap.get(n.id) ?? 0;
        for (const child of n.children) {
            walk(child);
        }
    }
    for (const node of nodes)
        walk(node);
}
export function buildCuBreakdown(nodes, totalConsumed, limit) {
    const perInstruction = [];
    function collect(n) {
        if (n.cuConsumed && n.cuConsumed > 0) {
            perInstruction.push({
                id: n.id,
                index: n.index,
                programName: n.programName,
                cu: n.cuConsumed,
                percentOfTotal: totalConsumed > 0 ? (n.cuConsumed / totalConsumed) * 100 : 0,
            });
        }
        for (const child of n.children)
            collect(child);
    }
    for (const node of nodes)
        collect(node);
    const overProvisioned = limit > totalConsumed * 1.5;
    const recommendedLimit = Math.ceil(totalConsumed * 1.05);
    const estimatedSavingsPercent = limit > 0 ? ((limit - recommendedLimit) / limit) * 100 : 0;
    return {
        totalConsumed,
        limit,
        perInstruction: perInstruction.sort((a, b) => b.cu - a.cu),
        overProvisioned,
        recommendedLimit,
        estimatedSavingsPercent: Math.max(0, estimatedSavingsPercent),
    };
}
//# sourceMappingURL=cu-parser.js.map